import useFrontendErrorLogged from './hooks/useFrontendErrorLogged';

const FrontendAPIErrorManager = ({ errors, id }) => {
  useFrontendErrorLogged(errors, id);
  return null;
};

export default FrontendAPIErrorManager;
